export const JSD_FIELD_ALIAS = 'jsd.field.displayName';
export const JSD_FIELD_HELPTEXT = 'jsd.field.helpText';

export const JSD_ISSUE_TYPE_HELPTEXT = 'jsd.simplified.issue.type.helpText';
export const JSD_IS_EMAIL_REQUEST_TYPE = 'jsd.simplified.issue.type.isEmail';
